/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Registry_Token_HintInputs */



/**
* | output |
* | --- |
* | "Read token for that registry. Relays that run this package receive it, so use a read-only token scoped to it. Left empty, a stored token is kept while the UR..." |
*
* @param {Partner_Connectors_Field_Registry_Token_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_registry_token_hint = /** @type {((inputs?: Partner_Connectors_Field_Registry_Token_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Registry_Token_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lese-Token für diese Registry. Relays, die dieses Paket ausführen, erhalten es – verwenden Sie also ein darauf beschränktes Nur-Lese-Token. Bleibt das Feld leer, wird ein gespeichertes Token beibehalten, solange die URL gleich bleibt.")
	return /** @type {LocalizedString} */ ("Read token for that registry. Relays that run this package receive it, so use a read-only token scoped to it. Left empty, a stored token is kept while the URL stays the same.")
});